const PLATFORM_ADMIN_EMAIL = 'admin@idemgo.com';

export function isPlatformAdminUser(user) {
  return user?.role === 'admin'
    && String(user?.email || '').trim().toLowerCase() === PLATFORM_ADMIN_EMAIL;
}
